import {
  faArrowUpRightDots,
  faLaptopMobile,
  faShieldCheck,
  faToolbox,
  faTools,
  faVrCardboard,
} from '@fortawesome/pro-regular-svg-icons';
import soc1 from 'src/images/svgs/business/soc1.svg';
import soc2 from 'src/images/svgs/business/soc2.svg';
import soc3 from 'src/images/svgs/business/soc3.svg';
import soc4 from 'src/images/svgs/business/soc4.svg';
import soc5 from 'src/images/svgs/business/soc5.svg';
import soc6 from 'src/images/svgs/business/soc6.svg';

export const maximizeValueCards = [
  {
    icon: faToolbox,
    title: 'Recruitment and evaluation',
    description: 'Cut hiring costs and boost retention with hands-on team training.',
    image: soc1,
  },
  {
    icon: faArrowUpRightDots,
    title: 'Onboarding and upskilling',
    description: 'Speed up onboarding and ramp-up time while building lasting careers through real-world training.',
    image: soc2,
  },
  {
    icon: faTools,
    title: 'Continuous skill development',
    description: 'Stay ahead of evolving threats with continuous, real-world, gamified training on TryHackMe.',
    image: soc3,
  },
  {
    icon: faVrCardboard,
    title: 'Cyberthreat simulations',
    description: 'Prepare for real breaches. Strengthen team response through simulated attacks.',
    image: soc4,
  },
  {
    icon: faShieldCheck,
    title: 'Compliance readiness',
    description: 'Demonstrate audit-ready skills and framework alignment through measurable, continuous training.',
    image: soc5,
  },
  {
    icon: faLaptopMobile,
    title: 'Upskilling technical teams',
    description: 'Build cyber security awareness and defensive expertise across IT, DevOps, and SysAdmin teams.',
    image: soc6,
  },
];

export const sliderSettings = {
  className: 'center',
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '0',
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  draggable: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        centerPadding: '200px',
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: false,
        infinite: true,
        variableWidth: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        infinite: true,
        variableWidth: false,
      },
    },
  ],
};
